import { useEffect, useRef } from "react";
import { Compass } from "lucide-react";
import { Reveal } from "./Reveal";

// Staged interior living-room panorama (CC0). Swap with a real Chateaux
// Cloudinary-hosted seller panorama once onboarded.
const PANORAMA_URL = "/panos/living.jpg";

export const Tour360 = () => {
  const containerRef = useRef(null);
  const viewerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el || !window.pannellum) return;
    viewerRef.current = window.pannellum.viewer(el, {
      type: "equirectangular",
      panorama: PANORAMA_URL,
      autoLoad: true,
      autoRotate: -2,
      showControls: true,
      crossOrigin: "anonymous",
      showFullscreenCtrl: true,
      backgroundColor: [11, 11, 15],
    });
    return () => {
      if (viewerRef.current) viewerRef.current.destroy();
    };
  }, []);

  return (
    <section className="py-24 md:py-32 bg-ink text-bone border-t border-bone/10" data-testid="tour360-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="max-w-3xl mb-12">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.2em] text-coral mb-4">360 tour app for realtors</p>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Walk the listing before you sign up.
            </h2>
            <p className="mt-6 text-base md:text-lg text-bone/70 leading-relaxed">
              This is a live 360° tour captured on a phone and stitched by Chateaux. Drag to look
              around &mdash; buyers get the same immersive walk-through from any QR scan.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="relative">
          <div className="relative w-full aspect-[16/10] md:aspect-[2/1] border border-bone/15 overflow-hidden">
            <div ref={containerRef} className="w-full h-full" data-testid="tour360-viewer" />
            <div className="pointer-events-none absolute top-4 left-4 z-10 flex items-center gap-2 bg-ink/70 backdrop-blur-md border border-bone/15 px-3 py-1.5">
              <Compass className="w-4 h-4 text-coral" />
              <span className="text-[11px] uppercase tracking-[0.15em] text-bone">Live 360° · drag to explore</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
